import {Typography} from '@mui/material';
import {t} from 'i18next';
import AurButton from '../aur-button/AurButton';
import {ReactComponent as ResetIcon} from '../../../assests/svg/reset.svg';

type Props = {
  message?: string;
  onRefresh?: () => void;
  containerClass?: string;
  containerHeight?: number;
  enableParentWrapper?: boolean;
};

const AurDataGridErrorOverlay: React.FC<Props> = ({
  containerClass = '',
  onRefresh,
  message,
  containerHeight,
  enableParentWrapper = true,
}) => {
  const renderContent = () => {
    let style = undefined;
    if (containerHeight) style = {height: `${containerHeight}px`};
    return (
      <div
        className={`aur-data-grid-error-overlay-container ${containerClass}`}
        data-testid="data-grid-error-overlay"
        style={style}
      >
        <Typography className="typo-text subhead4_size message-text">
          {message ?? t('common.contentFailedToLoad')}
        </Typography>
        <AurButton
          type="text"
          label={t('common.refresh')}
          size="Medium"
          startIcon={<ResetIcon width={24} height={24} aria-hidden="true" />}
          ariaLabel="Refresh Button"
          dataTestId="refresh-button"
          onClick={onRefresh}
        />
      </div>
    );
  };
  if (enableParentWrapper)
    return (
      <div className={`aur-data-grid-error-overlay-parent-wrapper`}>
        {renderContent()}
      </div>
    );
  return renderContent();
};

export default AurDataGridErrorOverlay;
